import type { SxProps, Theme } from "~/common/mui";
import CPDProgress from "~/features/cms/homepagePersonalization/cpd/components/cpdProgress/CPDProgress";

type Props = {
  totalCartValue?: number;
  sx?: SxProps<Theme>;
};

export default function ConnectedCPDProgress({ totalCartValue, sx }: Props) {
  const data = getCPDProgressData();

  if (!data) {
    return null;
  }

  const { label, invoice, gap, target, targetIndex, currency } = data;
  return (
    <CPDProgress
      totalCartValue={totalCartValue}
      sx={sx}
      label={label}
      invoice={invoice}
      target={target}
      targetIndex={targetIndex}
      currency={currency}
      gap={gap}
    />
  );
}

export const getCPDProgressData = () => {
  return window.SCHA.user.customerPerformanceGraphsData?.customerPerformanceProgressBanner;
};
